import { attributes, html } from 'BomdisoftComponents/html/index';

export type BrandOptions = {
  gap?: number;
  href?: string;
  logoHeight?: number;
  logoSrc?: string;
  logoWidth?: number;
  priority?: boolean;
  size?: number;
  testId?: string;
  wordmarkMarginBottom?: number;
  wordmarkMarginInlineStart?: number;
  wordmarkSuffix: string;
};

export const toBrandVariables = ({ gap = 0.75, logoHeight, logoWidth, size = 24, wordmarkMarginBottom = 0, wordmarkMarginInlineStart = 0 }: Omit<BrandOptions, 'wordmarkSuffix'>) => ({
  '--brand-gap': `${gap * 8}px`,
  '--brand-logo-h': `${logoHeight ?? size}px`,
  '--brand-logo-w': `${logoWidth ?? size}px`,
  '--brand-size': `${size}px`,
  '--brand-wordmark-mb': `${wordmarkMarginBottom}px`,
  '--brand-wordmark-mis': `${wordmarkMarginInlineStart}px`,
});

export const renderBrand = ({ href, logoSrc = '/images/logo.png', priority = false, testId = 'brand', wordmarkSuffix, ...sizing }: BrandOptions) => {
  const size = sizing.size ?? 24;
  const style = Object.entries(toBrandVariables(sizing))
    .map(([name, value]) => `${name}: ${value}`)
    .join('; ');
  const inner = html`<img${attributes({ alt: '', class: 'bomdisoft-brand-logo', decoding: 'async', fetchpriority: priority ? 'high' : undefined, height: sizing.logoHeight ?? size, loading: priority ? undefined : 'lazy', src: logoSrc, width: sizing.logoWidth ?? size })}><span class="bomdisoft-brand-wordmark">${wordmarkSuffix}</span>`;
  return href ? html`<a${attributes({ class: 'bomdisoft-brand', 'data-testid': testId, href, style })}>${inner}</a>` : html`<span${attributes({ class: 'bomdisoft-brand', 'data-testid': testId, style })}>${inner}</span>`;
};
